/** @prettier */

export default (data, map = (point) => point) => {
  const dataPointsPerDay = 24;
  const hourlyDaysAvailable = 5;

  return [...Array(hourlyDaysAvailable)].map((_, index) => {
    const start = dataPointsPerDay * index;
    const end = start + dataPointsPerDay;
    return data.slice(start, end).map(map);
  });
};
